import React, { useState } from 'react';
import apiClient from '../api/client';

function AboutUs() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [submitStatus, setSubmitStatus] = useState('');
  const [scholarshipStatus, setScholarshipStatus] = useState(() => {
    return localStorage.getItem('scholarship_applied') === 'true' ? 'sent' : '';
  }); // '', 'sending', 'sent', 'error'
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // Check if user is logged in
  React.useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) setIsLoggedIn(true);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus('sending');
    
    try {
      // Import axios directly to bypass auth interceptor
      const axios = (await import('axios')).default;
      const { awsConfig } = await import('../aws-config');
      
      const response = await axios.post(`${awsConfig.apiEndpoint}/contact`, formData, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      console.log('Contact form response:', response);
      
      setSubmitStatus('success');
      setTimeout(() => {
        setSubmitStatus('');
        setFormData({ name: '', email: '', message: '' });
      }, 5000);
    } catch (error) {
      console.error('Error sending message:', error);
      console.error('Error response:', error.response?.data);
      console.error('Error status:', error.response?.status);
      console.error('Full error:', error);
      setSubmitStatus('error');
      setTimeout(() => setSubmitStatus(''), 5000);
    }
  };

  return (
    <div style={{ maxWidth: '1400px', margin: '40px auto', padding: '0 20px', width: '100%', boxSizing: 'border-box' }}>
      <div className="card" style={{ textAlign: 'center', padding: '60px 24px', marginBottom: '30px' }}>
        <h1 style={{ fontSize: '48px', marginBottom: '20px', color: '#4f46e5' }}>
          About PrepSmart
        </h1>
        <p style={{ fontSize: '20px', color: '#666', maxWidth: '800px', margin: '0 auto' }}>
          Empowering students through accessible, quality education
        </p>
      </div>

      {/* Main Layout: Content + Contact Sidebar */}
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: window.innerWidth > 1024 ? '1fr 380px' : '1fr', 
        gap: '20px' 
      }}>
        
        {/* Left: Main Content */}
        <div>
          <div className="card" style={{ marginBottom: '30px' }}>
            <h2 style={{ fontSize: '32px', marginBottom: '20px', color: '#4f46e5' }}>Our Mission</h2>
            <p style={{ fontSize: '18px', lineHeight: '1.8', color: '#666', marginBottom: '20px' }}>
              At PrepSmart, we believe every student deserves access to <strong>world-class exam preparation</strong>, 
              regardless of their family's financial situation. Quality education shouldn't be a luxury—it should be 
              a right accessible to all.
            </p>
            <p style={{ fontSize: '18px', lineHeight: '1.8', color: '#666', marginBottom: '20px' }}>
              We're on a mission to <strong>democratize exam preparation</strong> by combining expert educational 
              content with smart technology. Our platform delivers the same quality of practice and feedback you'd expect 
              from expensive tutoring centers, but at a price every family can afford.
            </p>
            <p style={{ fontSize: '18px', lineHeight: '1.8', color: '#666', marginBottom: '0' }}>
              We're not just building a test prep platform—we're <strong>leveling the playing field</strong> so that 
              talent and hard work determine a student's success. Every child with the dedication 
              to succeed deserves the tools to make it happen.
            </p>
          </div>

          <div className="card" style={{ marginBottom: '30px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}>
            <h2 style={{ fontSize: '28px', marginBottom: '20px' }}>Why We're Different</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
              <div>
                <div style={{ fontSize: '36px', marginBottom: '10px' }}>💰</div>
                <h3 style={{ fontSize: '20px', marginBottom: '10px' }}>Affordable</h3>
                <p style={{ opacity: '0.9' }}>Free practice tests with optional premium bundles at minimal cost</p>
              </div>
              <div>
                <div style={{ fontSize: '36px', marginBottom: '10px' }}>💡</div>
                <h3 style={{ fontSize: '20px', marginBottom: '10px' }}>Smart Feedback</h3>
                <p style={{ opacity: '0.9' }}>Instant, personalized feedback and expert guidance on every question</p>
              </div>
              <div>
                <div style={{ fontSize: '36px', marginBottom: '10px' }}>🎯</div>
                <h3 style={{ fontSize: '20px', marginBottom: '10px' }}>Focused</h3>
                <p style={{ opacity: '0.9' }}>Specifically designed for NSW Selective High School preparation</p>
              </div>
              <div>
                <div style={{ fontSize: '36px', marginBottom: '10px' }}>🌟</div>
                <h3 style={{ fontSize: '20px', marginBottom: '10px' }}>Accessible</h3>
                <p style={{ opacity: '0.9' }}>Available 24/7 from anywhere with an internet connection</p>
              </div>
            </div>
          </div>

          <div className="card" style={{ marginBottom: '30px' }}>
            <h2 style={{ fontSize: '28px', marginBottom: '20px', color: '#4f46e5' }}>Our Story</h2>
            <p style={{ fontSize: '18px', lineHeight: '1.8', color: '#666', marginBottom: '20px' }}>
              PrepSmart was born from a simple observation: quality education resources shouldn't be a luxury. 
              Too many talented students miss opportunities because they can't afford expensive tutoring or 
              preparation courses.
            </p>
            <p style={{ fontSize: '18px', lineHeight: '1.8', color: '#666', marginBottom: '20px' }}>
              By combining modern technology with a commitment to accessibility, we're working to ensure that 
              every student has the tools they need to succeed in their exams.
            </p>
          </div>

          {/* Scholarship Program */}
          <div className="card" style={{ 
            marginBottom: '30px', 
            background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', 
            color: 'white',
            padding: '40px'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '20px' }}>
              <span style={{ fontSize: '48px' }}>🎓</span>
              <h2 style={{ fontSize: '28px', margin: 0 }}>PrepSmart Scholarship Program</h2>
            </div>
            <p style={{ fontSize: '18px', lineHeight: '1.8', opacity: '0.95', marginBottom: '20px' }}>
              We believe that a child's potential should never be limited by their family's financial circumstances. 
              That's why we offer free access to our Essential plan for students from families 
              experiencing financial hardship.
            </p>
            <p style={{ fontSize: '18px', lineHeight: '1.8', opacity: '0.95', marginBottom: '25px' }}>
              Every child deserves a fair chance. If cost is a barrier, we're here to help — no complicated 
              applications. Just click the button below and we'll send you a simple form to complete.
            </p>
            <div style={{ 
              background: 'rgba(255,255,255,0.15)', 
              borderRadius: '12px', 
              padding: '25px',
              marginBottom: '25px'
            }}>
              <h3 style={{ fontSize: '20px', marginBottom: '15px' }}>How It Works</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', fontSize: '16px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <span style={{ 
                    background: 'rgba(255,255,255,0.25)', 
                    borderRadius: '50%', 
                    width: '32px', 
                    height: '32px', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    fontWeight: 'bold',
                    flexShrink: 0
                  }}>1</span>
                  <span>Register a free account on PrepSmart</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <span style={{ 
                    background: 'rgba(255,255,255,0.25)', 
                    borderRadius: '50%', 
                    width: '32px', 
                    height: '32px', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    fontWeight: 'bold',
                    flexShrink: 0
                  }}>2</span>
                  <span>Click "Apply for Scholarship" below — we'll email you a pre-filled application form</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <span style={{ 
                    background: 'rgba(255,255,255,0.25)', 
                    borderRadius: '50%', 
                    width: '32px', 
                    height: '32px', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    fontWeight: 'bold',
                    flexShrink: 0
                  }}>3</span>
                  <span>Complete the form and send it back to <strong>prepsmart.help@gmail.com</strong></span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <span style={{ 
                    background: 'rgba(255,255,255,0.25)', 
                    borderRadius: '50%', 
                    width: '32px', 
                    height: '32px', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    fontWeight: 'bold',
                    flexShrink: 0
                  }}>4</span>
                  <span>We'll activate your child's Essential access within 24 hours once approved</span>
                </div>
              </div>
              
              {/* Apply for Scholarship Button */}
              <div style={{ textAlign: 'center', marginTop: '25px' }}>
                {scholarshipStatus === 'sent' ? (
                  <div style={{ 
                    background: 'rgba(255,255,255,0.25)', 
                    padding: '15px 25px', 
                    borderRadius: '8px',
                    fontSize: '16px'
                  }}>
                    ✅ Scholarship application sent! Please check the parent/guardian email registered with your account for an email from <strong>PrepSmart &lt;noreply@prepsmart.com.au&gt;</strong>. Hit reply, complete the form and send it back to us.
                  </div>
                ) : scholarshipStatus === 'error' ? (
                  <div style={{ 
                    background: 'rgba(255,100,100,0.3)', 
                    padding: '15px 25px', 
                    borderRadius: '8px',
                    fontSize: '16px',
                    marginBottom: '10px'
                  }}>
                    ❌ Something went wrong. Please try again or email us directly at prepsmart.help@gmail.com
                  </div>
                ) : (
                  <button
                    onClick={async () => {
                      if (!isLoggedIn) {
                        alert('Please register and log in first to apply for the scholarship.');
                        return;
                      }
                      setScholarshipStatus('sending');
                      try {
                        await apiClient.post('/scholarship-apply');
                        localStorage.setItem('scholarship_applied', 'true');
                        setScholarshipStatus('sent');
                      } catch (err) {
                        console.error('Scholarship apply error:', err);
                        setScholarshipStatus('error');
                        setTimeout(() => setScholarshipStatus(''), 5000);
                      }
                    }}
                    disabled={!isLoggedIn || scholarshipStatus === 'sending'}
                    style={{
                      padding: '16px 40px',
                      fontSize: '18px',
                      fontWeight: 'bold',
                      background: isLoggedIn ? 'white' : 'rgba(255,255,255,0.4)',
                      color: isLoggedIn ? '#059669' : 'rgba(255,255,255,0.7)',
                      border: 'none',
                      borderRadius: '8px',
                      cursor: isLoggedIn ? 'pointer' : 'not-allowed',
                      boxShadow: isLoggedIn ? '0 4px 12px rgba(0,0,0,0.2)' : 'none',
                      transition: 'transform 0.2s ease'
                    }}
                    onMouseEnter={(e) => isLoggedIn && (e.target.style.transform = 'translateY(-2px)')}
                    onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                  >
                    {scholarshipStatus === 'sending' ? '⏳ Sending...' : isLoggedIn ? '🎓 Apply for Scholarship' : '🔒 Login to Apply'}
                  </button>
                )}
                {!isLoggedIn && (
                  <p style={{ fontSize: '14px', opacity: '0.8', marginTop: '10px' }}>
                    You need to be logged in to apply. <a href="/register" style={{ color: 'white', fontWeight: 'bold' }}>Register here</a> or <a href="/login" style={{ color: 'white', fontWeight: 'bold' }}>Login</a>.
                  </p>
                )}
              </div>
            </div>
            <p style={{ fontSize: '16px', opacity: '0.85', fontStyle: 'italic', margin: 0 }}>
              "Education is the most powerful weapon which you can use to change the world." — Nelson Mandela
            </p>
          </div>
        </div>

        {/* Right Sidebar: Contact Form */}
        <div>
          <div className="card" style={{ padding: '30px', background: '#f0f9ff', position: 'sticky', top: '20px' }}>
            <h3 style={{ fontSize: '24px', marginBottom: '20px', color: '#4f46e5', textAlign: 'center' }}>
              Got Questions? Reach Us! 💬
            </h3>
            
            {/* Contact Channels */}
            <div style={{ marginBottom: '25px', paddingBottom: '25px', borderBottom: '2px solid #e5e7eb' }}>
              <div style={{ marginBottom: '15px' }}>
                <a 
                  href="mailto:prepsmart.help@gmail.com" 
                  style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '12px',
                    padding: '12px 16px',
                    background: 'white',
                    borderRadius: '8px',
                    textDecoration: 'none',
                    color: '#333',
                    border: '2px solid #e5e7eb',
                    transition: 'all 0.2s'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = '#4f46e5';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = '#e5e7eb';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  <span style={{ fontSize: '24px' }}>📧</span>
                  <div>
                    <div style={{ fontSize: '12px', color: '#666', marginBottom: '2px' }}>Email Us</div>
                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#4f46e5' }}>prepsmart.help@gmail.com</div>
                  </div>
                </a>
              </div>

              {/* Chat Bot - Coming Soon */}
              <div 
                style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '12px',
                  padding: '12px 16px',
                  background: '#f9fafb',
                  borderRadius: '8px',
                  border: '2px dashed #d1d5db',
                  color: '#9ca3af',
                  cursor: 'not-allowed'
                }}
              >
                <span style={{ fontSize: '24px' }}>💬</span>
                <div>
                  <div style={{ fontSize: '12px', marginBottom: '2px' }}>Live Chat Support</div>
                  <div style={{ fontSize: '14px', fontWeight: '600' }}>Coming Soon!</div>
                </div>
              </div>
            </div>
            
            {submitStatus === 'sending' && (
              <div style={{ 
                padding: '15px', 
                background: '#dbeafe', 
                color: '#1e40af', 
                borderRadius: '8px', 
                marginBottom: '20px',
                textAlign: 'center',
                fontWeight: '600'
              }}>
                ⏳ Sending message...
              </div>
            )}
            
            {submitStatus === 'success' && (
              <div style={{ 
                padding: '15px', 
                background: '#d1fae5', 
                color: '#065f46', 
                borderRadius: '8px', 
                marginBottom: '20px',
                textAlign: 'center',
                fontWeight: '600'
              }}>
                ✓ Message sent successfully! We'll get back to you soon.
              </div>
            )}
            
            {submitStatus === 'error' && (
              <div style={{ 
                padding: '15px', 
                background: '#fee2e2', 
                color: '#991b1b', 
                borderRadius: '8px', 
                marginBottom: '20px',
                textAlign: 'center',
                fontWeight: '600'
              }}>
                ✗ Failed to send message. Please email us directly at prepsmart.help@gmail.com
              </div>
            )}

            <h4 style={{ fontSize: '18px', marginBottom: '15px', color: '#4f46e5', textAlign: 'center' }}>
              Or Send Us a Message
            </h4>

            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#333', fontSize: '16px' }}>
                  Your Name
                </label>
                <input
                  type="text"
                  required
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  style={{
                    width: '100%',
                    padding: '12px',
                    borderRadius: '8px',
                    border: '2px solid #e5e7eb',
                    fontSize: '16px',
                    boxSizing: 'border-box'
                  }}
                  placeholder="Enter your name"
                />
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#333', fontSize: '16px' }}>
                  Email Address
                </label>
                <input
                  type="email"
                  required
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  style={{
                    width: '100%',
                    padding: '12px',
                    borderRadius: '8px',
                    border: '2px solid #e5e7eb',
                    fontSize: '16px',
                    boxSizing: 'border-box'
                  }}
                  placeholder="your@email.com"
                />
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#333', fontSize: '16px' }}>
                  Message
                </label>
                <textarea
                  required
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  rows="6"
                  style={{
                    width: '100%',
                    padding: '12px',
                    borderRadius: '8px',
                    border: '2px solid #e5e7eb',
                    fontSize: '16px',
                    boxSizing: 'border-box',
                    resize: 'vertical',
                    fontFamily: 'inherit'
                  }}
                  placeholder="How can we help you?"
                />
              </div>

              <button 
                type="submit"
                disabled={submitStatus === 'sending'}
                className="btn-primary"
                style={{ 
                  width: '100%', 
                  padding: '14px', 
                  fontSize: '18px', 
                  fontWeight: 'bold',
                  opacity: submitStatus === 'sending' ? 0.6 : 1,
                  cursor: submitStatus === 'sending' ? 'not-allowed' : 'pointer'
                }}
              >
                {submitStatus === 'sending' ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
